module.exports = __webpack_public_path__ + "VIPM7.png?ac338062d4d1b1a8d60113733aca4f7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM7.png
// module id = 152
// module chunks = 0